import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { initLenis, getLenis } from "@/lib/scroll";
import NavigationHeader from "@/components/NavigationHeader";
import FooterSection from "@/components/FooterSection";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import Contact from "@/pages/Contact";
import Start from "@/pages/Start";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        const lenis = getLenis();
        if (!el) return;
        if (lenis) lenis.scrollTo(el, { offset: -88, duration: 1.4 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => clearTimeout(timer);
    }
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => initLenis(), []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-ink font-sans text-slate-300 antialiased">
          <div className="noise-overlay pointer-events-none fixed inset-0 z-[5] opacity-[0.035]" aria-hidden="true" />
          <NavigationHeader />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/start" element={<Start />} />
          </Routes>
          <FooterSection />
          <Toaster />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
